import { createRoot } from 'react-dom/client';

import { t } from '@luna/i18n';
import type { LogoutType } from '@luna/utils-ts';

import styles from './LogoutMessage.module.scss';

const getLogoutMessage = (logoutType: LogoutType): string => {
    if (logoutType === 'locked' && t('app.logoutLocked')) {
        return t('app.logoutLocked');
    }

    return t('app.loggingOut');
};

export const renderLogoutMessage = (logoutType: LogoutType): void => {
    const logoutMessageEl = document.createElement('div');
    document.body.replaceChildren(logoutMessageEl);
    const root = createRoot(logoutMessageEl);
    root.render(
        <div id="logout-container">
            <br />
            <br />
            <div className={`pull-left ${styles.logoutMessageColor}`}>
                <h1 id="mainloading-hl">{getLogoutMessage(logoutType)}</h1>
            </div>
        </div>,
    );
};
